import { defineStore } from "pinia";
import { ref } from "vue";
import ApiAudits from "@/apis/ApiAudits";
import { exceptionWrapper, useTableData } from "./piniaUtils";

export const useAuditsStore = defineStore("audits", () => {
  const audits = ref([]);
  const loading = ref(false);
  const error = ref(false);
  const availableTypes = ref([]);
  const { table, resetPage } = useTableData({ totalItems: 0 });

  const getAudits = (params, next = false) =>
    exceptionWrapper(
      async () => {
        const response = await ApiAudits.getAudits({
          ...params,
          page: table.page + 1,
          per_page: table.perPage,
        });

        if (next) {
          audits.value = [...audits.value, ...response.audits];
        } else {
          audits.value = response.audits;
        }

        table.hasMore = response.pagination.page < response.pagination.total_pages;
        table.page = response.pagination.page;
        table.totalCount = response.pagination.total_count;
      },
      { loading, error, toast: true },
    );

  const getFilters = () =>
    exceptionWrapper(
      async () => {
        const response = await ApiAudits.getFilters();
        availableTypes.value = response.auditable_types;
      },
      { loading, error, toast: true },
    );

  return {
    audits,
    loading,
    error,
    availableTypes,
    table,
    getAudits,
    getFilters,
    resetPage,
  };
});
